<div class="flex-item-container {{ task.isCancelled ? 'cancelled' : '' }}" *ngIf="pickupAddress">
  <div class="fixed-width-label">
    <span routeItineraryDottedLineIcon iconClass="fa fa-circle-o">
      {{ pickupAddress.earliestTime | date : 'HH:mm' }} -
      {{ pickupAddress.latestTime | date : 'HH:mm' }}
    </span>
  </div>
  <div class="flex-content-container" *ngIf="!carryOverFromHome">
    <div *ngIf="pickupAddress.address?.businessName">{{ pickupAddress.address.businessName }}</div>
    <div *ngIf="pickupAddress.address?.addressLine1">{{ pickupAddress.address.addressLine1 }}</div>
    <div *ngIf="pickupAddress.address?.addressLine2">{{ pickupAddress.address.addressLine2 }}</div>
    <div *ngIf="pickupAddress.address?.city">{{ pickupAddress.address.city }}</div>
    <div *ngIf="pickupAddress.address?.postcode">{{ pickupAddress.address.postcode }}</div>
    <div *ngIf="pickupAddress.address?.what3Words" class="subtitle-text what3words-row">
      <what3words-logo></what3words-logo>
      <span>{{ pickupAddress.address.what3Words }}</span>
    </div>
    <div *ngIf="pickupAddress.timeOnSite" class="subtitle-text">
      {{ pickupAddress.timeOnSite }} est. on site
    </div>
  </div>
  <div class="flex-content-container" *ngIf="carryOverFromHome">
    <div>
      Leave Home <span class="text-ds-light">({{ pickupAddress.address.postcode }})</span>
    </div>
  </div>
</div>

<div
  class="drive-time-wrapper {{ task.isCancelled ? 'cancelled' : '' }}"
  *ngIf="pickupAddress && dropOffAddress"
>
  <div class="fixed-width-spacer"></div>
  <div class="drive-time-est">
    <span routeItineraryDottedLineIcon iconClass="fa fa-car">
      {{ movementTime | minutesToHoursMinutes }},
      {{
        carryOverFromHome || carryOverToHome ? (distance | number : '1.0-0') : (distance | toMiles)
      }}
      miles driving
    </span>
    <span class="tag bolt mt-2 mb-2" *ngIf="task?.estimatedChargeTime > 0">
      <img src="assets/images/icons/svg/ev-icon.svg" alt="icon" class="icon" /> inc.
      {{ chargeTime }} mins EV charging
    </span>
  </div>
</div>

<div class="flex-item-container {{ task.isCancelled ? 'cancelled' : '' }}" *ngIf="dropOffAddress">
  <div class="fixed-width-label">
    <span routeItineraryDottedLineIcon iconClass="fa fa-circle-o">
      {{ dropOffAddress.earliestTime | date : 'HH:mm' }} -
      {{ dropOffAddress.latestTime | date : 'HH:mm' }}
    </span>
  </div>
  <div class="flex-content-container" *ngIf="!carryOverToHome">
    <div *ngIf="dropOffAddress.address?.businessName">
      {{ dropOffAddress.address.businessName }}
    </div>
    <div *ngIf="dropOffAddress.address?.addressLine1">
      {{ dropOffAddress.address.addressLine1 }}
    </div>
    <div *ngIf="dropOffAddress.address?.addressLine2">
      {{ dropOffAddress.address.addressLine2 }}
    </div>
    <div *ngIf="dropOffAddress.address?.city">{{ dropOffAddress.address.city }}</div>
    <div *ngIf="dropOffAddress.address?.postcode">{{ dropOffAddress.address.postcode }}</div>
    <div *ngIf="dropOffAddress.address?.what3Words" class="subtitle-text what3words-row">
      <what3words-logo></what3words-logo>
      <span>{{ dropOffAddress.address.what3Words }}</span>
    </div>
    <div *ngIf="dropOffAddress.timeOnSite" class="subtitle-text">
      {{ dropOffAddress.timeOnSite }} est. on site
    </div>
  </div>
  <div class="flex-content-container" *ngIf="carryOverToHome">
    <div>
      Arrive Home <span class="text-ds-light">({{ dropOffAddress.address.postcode }})</span>
    </div>
  </div>
</div>
